package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.data.common.DocumentTextType
import com.eladfinish.bible.contest.data.common.DocumentsExporter
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.data.common.stringResolver.resolveString
import com.eladfinish.bible.contest.platform.share.ShareTextFormatter
import com.eladfinish.bible.contest.search_report
import dev.icerock.moko.resources.desc.StringDesc
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.Padding
import kotlinx.datetime.format.char
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock

class SaveSearchResultsToFileUseCase(
    private val assetReader: AssetReader,
    private val documentsExporter: DocumentsExporter,
    private val shareTextFormatter: ShareTextFormatter,
    private val stringResolver: StringResolver,
) {

    companion object {
        const val SEARCH_FOLDER = "תוצאות חיפוש"
    }

    operator fun invoke(
        searchResultsText: StringDesc,
        searchMode: StringDesc,
        content: String,
    ): Boolean {
        val documentTextType: DocumentTextType = DocumentTextType.TXT

        return documentsExporter.saveTextFileToDocuments(
            folder = SEARCH_FOLDER,
            name = createBibleFilename(),
            content = buildString {
                append("*${stringResolver.resolveString(SharedRes.strings.search_report)}*")
                append("\n")
                append(stringResolver.resolveString(searchResultsText))
                append("\n")
                append(stringResolver.resolveString(searchMode))
                append("\n")
                append(content)
                append("\n\n")
                append(
                    shareTextFormatter.format(
                        assetReader = assetReader,
                        documentTextType = documentTextType,
                    )
                )
            },
            type = documentTextType,
        )
    }

    private fun createBibleFilename(
        timeZone: TimeZone = TimeZone.currentSystemDefault(),
    ): String {
        val now = Clock.System.now().toLocalDateTime(timeZone)
        return "bible_${now.format(fileNameFormat)}"
    }

    private val fileNameFormat = LocalDateTime.Format {
        day(padding = Padding.ZERO)
        monthNumber(padding = Padding.ZERO)
        year()
        char('_')
        hour(padding = Padding.ZERO)
        minute(padding = Padding.ZERO)
        second(padding = Padding.ZERO)
    }

}
